<div class="full-height-container">
  <div class="tall-container" style.height="{{ scrollableHeight$ | async }}px">
    <div #stickyContainer class="sticky-container">
      <div class="inner-container" style.transform="translateX({{ translate$ | async }}px)">
        <ng-content />
      </div>
    </div>
  </div>
</div>
